export default {
    computed: {
        autoFillCityId() {
            return [this.data, this.publicCityIds];
        },
    },
    watch: {
        autoFillCityId() {
            const { data, publicCityIds } = this;
            // 当仅有一条数据时，自动填充可选择的城市id，提效...
            if ((data && data.length && data.length === 1) && (publicCityIds && publicCityIds.length)) {
                data[0].cityIds = this.publicCityIds;
            }
        },
    },
};
